
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IFormMetadata, ISearchableGridFormMetadata, TreeNode, Tuple } from "@tylertech/tyler-api-types";

/**
 * FormMetadataService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class FormMetadataService {
    private readonly $apiService = inject(ApiService);
    
    AllViewPaths(): Promise<TreeNode[]> {
        return this.$apiService.sendAuth("IFormMetadataService/AllViewPaths");
    }
    AllViewPathsString(): Promise<string[]> {
        return this.$apiService.sendAuth("IFormMetadataService/AllViewPathsString");
    }
    AllViewPathsStringByApp(): Promise<{ [key: string]: string[] }> {
        return this.$apiService.sendAuth("IFormMetadataService/AllViewPathsStringByApp");
    }
    Get(filterString?: string): Promise<IFormMetadata[]> {
        return this.$apiService.sendAuth("IFormMetadataService/Get", null, filterString);
    }
    GetByType(type: string, filterString?: string): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IFormMetadataService/GetByType", type, filterString);
    }
    GetEditForm(pathAndType: Tuple<string, string>): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IFormMetadataService/GetEditForm", pathAndType);
    }
    GetForm(path: string, filterString?: string): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IFormMetadataService/GetForm", path, filterString);
    }
    GetFormAssembly(formPath: string): Promise<string> {
        return this.$apiService.sendAuth("IFormMetadataService/GetFormAssembly", formPath);
    }
    GetPaths(filterString?: string): Promise<TreeNode[]> {
        return this.$apiService.sendAuth("IFormMetadataService/GetPaths", null, filterString);
    }
    GetSearchableGridScreens(filterString?: string): Promise<ISearchableGridFormMetadata[]> {
        return this.$apiService.sendAuth("IFormMetadataService/GetSearchableGridScreens", null, filterString);
    }
}
